import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { CommonService } from 'src/app/services/common.service';
import { Chart } from 'chart.js';


@Component({
  selector: 'app-opponents',
  templateUrl: './opponents.component.html',
  styleUrls: ['./opponents.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class OpponentsComponent implements OnInit {
  opponentsList: any;
  visible: boolean;
  playerName:any='';
  private lazyLoadEvent: LazyLoadEvent;
  public item;
  public compare:boolean = false;
  opponentselement: any;
  public profileDetails;
  public loggedInUser;
  public playerRating;
  public userId;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  compareList:any;
  paginationOption;
  chartData:any;
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 11
    },
    legend: {
      position: 'bottom'
    }
  }
  public Top_config: SwiperConfigInterface = {
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    

    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: false,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  };

  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  constructor(
  
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
    private commonService : CommonService
  ) {

  }
  ngOnInit(): void {
    //this.loadOpponents(this.lazyLoadEvent);
    this.getCompareSkillList(this.lazyLoadEvent);
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    this.rankData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Rank',
          data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
          fill: false,
          borderColor: '#42A5F5',
          tension: .4
        },
      ]
    };
    this.skillsData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Skills',
          data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
          fill: false,
          borderColor: '#7CFC00',
          tension: .4
        },
      ]
    };

  


    // this.data = {
    //   // labels: ['Skill', 'Skill', 'Skill'],
    //   datasets: [
    //     {
    //       label: 'skill',
    //       data: [800, 210, 150, 225, 435, 100],
    //       borderRadius: 5,
    //       cutout: 60,
    //       cutoutPercentage: 40,
    //       backgroundColor: [
    //           'rgb(235, 124, 166)',
    //           'rgb(255, 172, 200)',
    //           'rgb(204, 111, 248)',
    //           'rgb(124, 92, 252)',
    //           'rgb(92, 175, 252)',
    //           'rgb(161, 169, 254)'
    //       ],
    //       hoverOffset: 10,
    //       spacing: 8
    //     }]
    // };

  //  this.data = {
    
  //   type: 'doughnut',
  //   weight:10,
  //     // labels: ['Skill', 'Skill', 'Skill'],
  //     datasets: [
  //       {
  //         label: 'skill',
  //         data: [800, 210, 150, 225, 435, 100],
  //         borderRadius: 5,
  //         cutout: 30,
  //         cutoutPercentage: 10,
  //         backgroundColor: [
  //             'rgb(235, 124, 166)',
  //             'rgb(255, 172, 200)',
  //             'rgb(204, 111, 248)',
  //             'rgb(124, 92, 252)',
  //             'rgb(92, 175, 252)',
  //             'rgb(161, 169, 254)'
  //         ],
  //         hoverOffset: 5,
  //         spacing: 8
          
  //       }]
  //   }
    
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
    this.paginationOption = environment.pagination;
    this.getUserDetails(this.userId);
    this.getCareerDetails();
    //this.getOpponentsList();
    this.getHighestSkillJumpData();
    this.getTournamentsList();
    this.getCompareSkillList(this.lastTableLazyLoadEvent);
    this.getTournamentScorSkills()
  }
  // loadOpponents(event: LazyLoadEvent) {
  //   this.lazyLoadEvent = event;
  //   let pagenumber = 1;
  //   let params = "";
  //   let rows = 9;
  //   let query = "?filterByDisable=false&filterByStatus=true";
  //   if (event !== undefined) {
  //     if (event.first != undefined && event.first == 0) {
  //       pagenumber = event.first + 1;
  //     } else if (event.first != undefined && event.first > 0) {
  //       pagenumber = (event.first / event.rows) + 1;
  //     } else {
  //       pagenumber = 1;
  //     }
  //     if (event.rows != undefined) {
  //       rows = event.rows;
  //     } else {
  //       rows = 9;
  //     }
  //   }
  //   // alert(this.stateCode);
  //   // alert(this.cityName);
  //   // if (this.stateCode != undefined && this.stateCode != "") {
  //   //   params += "&filterByStatecode=" + this.stateCode;
  //   // }
  //   // if (this.cityName != undefined && this.cityName != "") {
  //   //   params += "&filterByCityName=" + this.cityName;
  //   // }

  //   // if (this.hardVal) {
  //   //   params += "&filterByHard=" + this.hardVal;
  //   // }
  //   // if (this.grassVal) {
  //   //   params += "&filterByGrass=" + this.grassVal;
  //   // }
  //   // if (this.clayVal) {
  //   //   params += "&filterByClay=" + this.clayVal;
  //   // }

  //   query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;

  //   this.opponentsService.getOpponentsList(query).subscribe(
  //     data => {
  //       //console.log("xxx", data);
  //       this.loading = false;
  //       this.opponentsList = data.data.items;
  //       this.totalRecords = data.data.totalCount;
  //       this.opponentsList.forEach((element) => {
  //         // this.imagedataa = element['academypic'];
  //       })
  //     },
  //     err => {
  //       this.errorMessage = err.error.message;
  //     }
  //   )
  // }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
        }

      }, err => {

      });

  }

  getCareerDetails() {
    this.careerService.getCareerDetails().then(
      data => {

        this.careerDetails = data[0];

      }, err => {

      });
  }

  getOpponentsList() {
    this.opponentsService.getOpponentsList().then(
      data => {
        this.opponentList = data;


      }, err => {

      }
    )
  }
  getCompareSkillList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 18;
    let query='';
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 18;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.tournamentsService.getCompareSkillList(query).subscribe(
      data=>{
        this.loading = false;
        this.compareList = data.data;
        this.compareList.forEach((res:any)=>{  
        
          let tmparray=[];
          res.opponentCharts.forEach((rating:any)=>{
            tmparray.push(rating.TotalRating);
          res.opponentCharts.options = {
            title: {
              display: true,
              text: 'My Title',
              fontSize: 11
            },
            legend: {
              position: 'bottom'
            }
          }
          res.opponentCharts.TotalRating = {
            type: 'doughnut',
            weight: 2,
            datasets: [
              {
                data: tmparray,
                borderRadius: 5,
                backgroundColor: [
                  '#20b033 ',
                  '#20b033',
                  '#20b033',
                  '#20b033',
                  '#20b033',
                  '#20b033'
                ],
                hoverOffset: 0,
                spacing: 8,
                cutout: 30,
  
              }]
          }
            })
          
        }) 
        this.totalRecords = data.totalCount;
      },
      err => {
      });
  
  }
  getHighestSkillJumpData() {
    this.careerService.getHighestSkillJumpDetails().then(
      data => {

        this.highestSkillJumpDetails = data;

      }, err => {

      });
  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        this.tournamentList = data;

      }, err => {

      });
  }
  onClickCompare(){
    this.compare=true;

  }
  OnClickCompareRemove(){
    this.compare=false;
  }

  showDialog() {
    this.visible = true;
}

searchPlayer(){

  let query='';
  query =`filterByName=${this.playerName}`
  if(this.playerName === ''){
    query = 'pageNumber=1&pageSize=18'
  }
  this.tournamentsService.getCompareSkillList(query).subscribe(
    data=>{
      this.loading = false;
      this.compareList = data.data;
      this.compareList.forEach((res:any)=>{  
        
        let tmparray=[];
        res.opponentCharts.forEach((rating:any)=>{
          tmparray.push(rating.TotalRating);
        res.opponentCharts.options = {
          title: {
            display: true,
            text: 'My Title',
            fontSize: 11
          },
          legend: {
            position: 'bottom'
          }
        }
        res.opponentCharts.TotalRating = {
          type: 'doughnut',
          weight: 2,
          datasets: [
            {
              data: tmparray,
              borderRadius: 5,
              backgroundColor: [
                '#20b033 ',
                '#20b033',
                '#20b033',
                '#20b033',
                '#20b033',
                '#20b033'
              ],
              hoverOffset: 0,
              spacing: 8,
              cutout: 30,

            }]
        }
          })
        
      }) 
    },
    err => {
    });
}

getTournamentScorSkills(){
  this.careerService.getTournamentScoreSkills().subscribe(
    data => {
     
      this.playerRating=data.data.highestskilljump.playerRating;
    })
}


}
